/**
 * 页面class操作类
 * 创建时间：2017-04-11
 *   创建人：zhanlz
 */
const trim = /^\s+|\s+$/g;
const whitespace = /\s+/g;

function interpret(input) {
    return typeof input === 'string' ? input.replace(trim, '').split(whitespace) : input;
}

function classes(el) {
    if (isElement(el)) {
        return el.className.replace(trim, '').split(whitespace);
    }

    return [];
}

function set(el, input) {
    if (isElement(el)) {
        el.className = interpret(input).join(' ');
    }
}

function add(el, input) {
    const current = remove(el, input);
    const values = interpret(input);

    current.push.apply(current, values);
    set(el, current);

    return current;
}

function remove(el, input) {
    const current = classes(el);
    const values = interpret(input);

    values.forEach(value => {
        const i = current.indexOf(value);
        if (i !== -1) {
            current.splice(i, 1);
        }
    });

    set(el, current);

    return current;
}

function contains(el, input) {
    const current = classes(el);
    const values = interpret(input);

    return values.every(value => {
        return current.indexOf(value) !== -1;
    });
}

function isElement(o) {
    const elementObjects = typeof HTMLElement === 'object';
    return elementObjects ? o instanceof HTMLElement : isElementObject(o);
}

function isElementObject(o) {
    return o &&
        typeof o === 'object' &&
        typeof o.nodeName === 'string' &&
        o.nodeType === 1;
}


function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}
function toggleScroll(type,str,self){
	const org=document.querySelector(str);  
	if(type==='open'){
		org.style.overflow='auto';
	}else if(type==='close'){ 
		org.style.overflow='hidden';
		self.scrollTop = org.scrollTop === 0 ? '-10px' : org.scrollTop - 10 + 'px'; 
	} 
}
export default {
    add,
    remove,
    contains,
    has: contains,
    set,
    get: classes,
    addClass,
    removeClass,
    toggleScroll
};



// WEBPACK FOOTER //
// ./src/util/classlist.js